import React, { Component } from "react";
import firebase from "firebase";
import FileUploader from "react-firebase-file-uploader"
import InputLabel from '@material-ui/core/InputLabel';
import ProfilePic from "../images/profile-pic.png"

export default class PhotoUploader extends Component {
    state = {
      file_name: "",
      isUploading: false,
      progress: 0,
      photo_url: "",
      isChanged:false
    };

    sendData = () => {
        this.props.parentCallback(this.state.file_name);
        this.setState({isChanged:true});
    }
    
    handleUploadStart = () => {this.setState({ isUploading: true, progress: 0 });}
    
    handleProgress = progress => this.setState({ progress });

    handleUploadError = error => {
        this.setState({ isUploading: false });
        console.error(error);
    };

    handleUploadSuccess = filename => {
        console.log(filename);
        this.setState({ file_name: filename, progress: 100, isUploading: false });
        firebase
        .storage()
        .ref("images")
        .child(filename)
        .getDownloadURL()
        .then(url => this.setState({ photo_url: url }));
        this.sendData();
    };

    async componentWillMount()  {
        if (this.props.photo_name != undefined && !this.state.isChanged) {
            firebase
            .storage()
            .ref("images")
            .child(this.props.photo_name)
            .getDownloadURL()
            .then(url => this.setState({ photo_url: url }));
        }
    }
    
    render() {
        let display;
        if (this.state.photo_url !== '') {
          display = <img style={{borderRadius: '50%', height:"80px", width:"80px"}} src={this.state.photo_url} />
        } else {
          display = <img src={ProfilePic} />
        }
        return (
          <div>
            <form>
              {/* {this.state.isUploading && <p>Progress: {this.state.progress}</p>}  */}
              <InputLabel style={{backgroundColor: '#F6F7F9', color: 'white', padding: 10, borderRadius: 4, cursor: 'pointer'}}>
              {display};
              <FileUploader
                hidden
                accept="image/*"
                name="avatar"
                randomizeFilename={true}
                storageRef={firebase.storage().ref("images")}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
                maxHeight={150}
                maxWidth={150}
              /></InputLabel>
            </form>
          </div>
        );
      }
}

